/** Build Konva Rect props for page background (solid, linear/radial gradient). */
export function konvaBackgroundRectProps({ bgType, bgColor, bgGradientFrom, bgGradientTo, pageW, pageH }) {
  const base = { x: 0, y: 0, width: pageW, height: pageH, listening: false };

  if (bgType === 'gradient-linear') {
    return {
      ...base,
      fillLinearGradientStartPoint: { x: 0, y: 0 },
      fillLinearGradientEndPoint: { x: pageW, y: pageH },
      fillLinearGradientColorStops: [0, bgGradientFrom || '#6366f1', 1, bgGradientTo || '#a855f7'],
    };
  }

  if (bgType === 'gradient-radial') {
    const cx = pageW / 2;
    const cy = pageH / 2;
    const r = Math.max(pageW, pageH) / 2;
    return {
      ...base,
      fillRadialGradientStartPoint: { x: cx, y: cy },
      fillRadialGradientEndPoint: { x: cx, y: cy },
      fillRadialGradientStartRadius: 0,
      fillRadialGradientEndRadius: r,
      fillRadialGradientColorStops: [0, bgGradientFrom || '#6366f1', 1, bgGradientTo || '#a855f7'],
    };
  }

  return {
    ...base,
    fill: bgColor || '#ffffff',
  };
}
